const currentDomain = window.location.hostname
const isLocalhost = currentDomain === 'localhost' || currentDomain === '127.0.0.1'

let domain = currentDomain
if (isLocalhost) {
	domain = 'localhost'
} else if (currentDomain.endsWith('runmyresto.ch')) {
	domain = '.runmyresto.ch'
} else if (currentDomain.endsWith('hssoft.com')) {
	domain = '.hssoft.com'
}

const amplifyConfig = {
	Auth: {
		// REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
		identityPoolId: import.meta.env.VITE_IDENTITYPOOL_ID,

		// REQUIRED - Amazon Cognito Region
		region: import.meta.env.VITE_AWS_REGION,

		// OPTIONAL - Amazon Cognito User Pool ID
		userPoolId: import.meta.env.VITE_USERPOOL_ID,

		// OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
		userPoolWebClientId: import.meta.env.VITE_USERPOOL_CLIENTID,

		// storage: amplifyStorage,

		cookieStorage: {
			// REQUIRED - Cookie domain (only required if cookieStorage is provided)
			domain,
			// OPTIONAL - Cookie path
			path: '/',
			// OPTIONAL - Cookie expiration in days
			expires: 365,
			// OPTIONAL - Cookie secure flag
			// Either true or false, indicating if the cookie transmission requires a secure protocol (https).
			secure: !isLocalhost,
			// OPTIONAL - SameSite attribute: 'strict' | 'lax' | 'none'
			// 'none' + secure:true is required for cross-site SSO redirects (Cognito hosted UI)
			sameSite: 'lax'
		}

		// OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
		// authenticationFlowType: 'USER_PASSWORD_AUTH'
	},
	Storage: {
		bucket: import.meta.env.VITE_S3_BUCKET, //REQUIRED -  Amazon S3 bucket
		region: import.meta.env.VITE_AWS_REGION //OPTIONAL -  Amazon service region
	},
	Analytics: {
		disabled: true
	}
}

export default amplifyConfig
